import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import UniversalModal from "../../universalModal";
import NotificationWindow from "../../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";

import {
  createPosition,
  updatePosition,
} from "../../../../../redux/directoryMaintenance/positionsReducer/actionPositions";

import { getDataPositionsModal } from "./constantsPositionsModal";

import { headerName, setOptionsSubLevel } from "./constantsPositionsModal";

import { CLEAR_POSITION } from "../../../../../redux/types";

const PositionsModal = ({ setShow, show, type, setSave }) => {
  const dispatch = useDispatch();

  const [fields, setFields] = useState([]);
  const [initialFieldsData, setInitialFieldsData] = useState({});
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);

  const positionsReducer = useSelector((state) => state.positionsReducer);

  const allGimsSubLevels = useSelector(
    (state) => state.dictionaryReducer.allGimsSubLevels,
  );

  async function setParamsForOptions() {
    setFields(Object.values(getDataPositionsModal()));
  }

  const handleSaveClick = async (data) => {
    if (type === "add") {
      dispatch(
        createPosition({
          posName: data.posName,
          gimsSubLevel: data.gimsSubLevel,
        }),
      );
      return false;
    }

    if (type === "edit") {
      const changedValues = {};
      for (let key in data) {
        if (data[key] !== positionsReducer.position[key]) {
          changedValues[key] = data[key];
        }
      }
      dispatch(updatePosition(positionsReducer.position.posId, changedValues));
      return false;
    }
    // setSave();
    // setShow(false);
  };

  const handleOnHide = () => {
    setShow(false);
    dispatch({
      type: CLEAR_POSITION,
    });
  };

  useEffect(() => {
    setParamsForOptions().then();
  }, []);

  useEffect(() => {
    if (fields) {
      const initialDataArray = fields.map((field) => ({
        key: field.key,
        value: field.type === "text" ? "" : 0,
      }));
      setInitialFieldsData(initialDataArray);
    }
  }, [fields]);

  useEffect(() => {
    if (allGimsSubLevels.length > 0) setOptionsSubLevel(allGimsSubLevels);
  }, []);
  useEffect(() => {
    if (allGimsSubLevels.length > 0) setOptionsSubLevel(allGimsSubLevels);
  }, [allGimsSubLevels]);

  useEffect(() => {
    if (positionsReducer.message !== "") {
      setShowNotificationWindow(!showNotificationWindow);
    }
  }, [positionsReducer.message]);

  return (
    <>
      <UniversalModal
        show={show}
        onHide={() => setShow(false)}
        onSave={(data) => handleSaveClick(data)}
        fields={fields}
        initialFieldsData={initialFieldsData}
        initialData={{ ...positionsReducer.position }}
        headerName={headerName[type]}
        type={type}
      />
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        onClose={() => {
          if (positionsReducer.isSaved) {
            handleOnHide();
          }
          if (!positionsReducer.isSaved) {
            setShowNotificationWindow(!showNotificationWindow);
            dispatch({ type: CLEAR_POSITION });
          }
        }}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={positionsReducer.message}
      />
    </>
  );
};

export default PositionsModal;
